export const getTranslations = t => {
  return {
    carouselLeftArrow: t("kf.plp.label.carouselLeftArrow"),
    carouselRightArrow: t("kf.plp.label.carouselRightArrow"),
  }
}
